import { render } from "./ResultMessageModal.vue?vue&type=template&id=7883ae2a&scoped=true"
import script from "./ResultMessageModal.vue?vue&type=script&lang=js"
export * from "./ResultMessageModal.vue?vue&type=script&lang=js"

import "./ResultMessageModal.vue?vue&type=style&index=0&id=7883ae2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7883ae2a"]])

export default __exports__